<template>
  <div>
    <!-- <Loader /> -->
    <CustomLoader :loading="accountLoading" />
    <!-- <Customizer
      @onLogo="changeLogo"
      @toggle="sidebarMini"
      @animationChange="routerAnimationChange"
    /> -->
    <div class="wrapper">
      <!-- Sidebar  -->
      <SmallSidebar
        v-if="$route.name === 'dashboard.home-5'"
        :logo="SmallSidebarLogo"
        @toggle="sidebarMini"
      />
      <Sidebar
        :items="verticalMenu"
        :logo="logo"
        :onlyLogo="onlyLogo"
        :onlyLogoText="onlyLogoText"
        @toggle="sidebarMini"
        :toggleButton="toggleSideIcon"
        :sidebarGroupTitle="sidebarGroupTitle"
      />
      <!-- TOP Nav Bar -->
      <DemoNavbar2
        :homeURL="{ name: 'dashboard' }"
        :sidebarGroupTitle="sidebarGroupTitle"
        @toggle="sidebarMini"
        :logo="logo"
      >
        <template slot="responsiveRight">
          <ul class="navbar-nav ml-auto navbar-list">
            <!-- <li class="nav-item" v-nav-toggle>
              <a class="search-toggle iq-waves-effect language-title" href="#"
                ><img
                  :src="selectedLang.image"
                  alt="img-flaf"
                  class="img-fluid mr-1"
                  style="height: 16px; width: 16px" />
                {{ selectedLang.title }} <i class="ri-arrow-down-s-line"></i
              ></a>
              <div class="iq-sub-dropdown">
                <a
                  class="iq-sub-card"
                  href="javascript:void(0)"
                  v-for="(lang, i) in langsOptions"
                  :key="`Lang${i}`"
                  @click="langChange(lang)"
                >
                  <img
                    :src="lang.image"
                    alt="img-flaf"
                    class="img-fluid mr-2"
                  />{{ lang.title }}
                </a>
              </div>
            </li>
            <li class="nav-item" v-nav-toggle>
              <a
                href="javascript:void(0)"
                class="iq-waves-effect"
                :class="cartCount > 0 ? 'search-toggle' : ''"
              >
                <i class="ri-shopping-cart-2-line" />
                <span class="menu-tag ml-2">{{ cartCount }}</span>
              </a>
              <div class="iq-sub-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">{{ $t("nav.allCarts") }}</h5>
                    </div>
                    <div
                      class="iq-sub-card"
                      v-for="(item, index) in cartItems"
                      :key="index"
                    >
                      <div class="media align-items-center">
                        <div
                          class="
                            w-20
                            text-center
                            d-none
                            justify-content-center
                            d-md-block
                          "
                        >
                          <img
                            :src="item.image"
                            :alt="item.name"
                            class="w-100 align-self-center mr-3"
                          />
                        </div>
                        <div class="media-body ml-3">
                          <b-button
                            variant=" iq-bg-danger mt-3"
                            size="sm"
                            class="float-right"
                            @click="removeToCart(item)"
                            >X</b-button
                          >
                          <h6 class="mb-0">
                            {{ item.name.substring(0, 20) + "..." }}
                          </h6>
                          <p class="mb-0 font-size-12">
                            {{ item.description.substring(0, 20) + "..." }}
                          </p>
                          <p class="mb-0">
                            <b>$ {{ item.price }}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <router-link :to="{ name: 'app.e-commerce.cart' }"
                      ><b-button variant=" iq-bg-primary" block
                        ><i class="fas fa-cart-plus" />{{
                          $t("nav.viewCarts")
                        }}</b-button
                      ></router-link
                    >
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item" v-nav-toggle>
              <a href="#" class="search-toggle iq-waves-effect">
                <lottie
                  :option="require('../assets/images/small/lottie-bell')"
                  id="lottie-beil"
                />
                <span class="bg-danger dots"></span>
              </a>
              <div class="iq-sub-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">
                        {{ $t("nav.allNotifications")
                        }}<small class="badge badge-light float-right pt-1"
                          >4</small
                        >
                      </h5>
                    </div>
                    <a
                      href="#"
                      class="iq-sub-card"
                      v-for="(item, index) in notification"
                      :key="index"
                    >
                      <div class="media align-items-center">
                        <div class="">
                          <img
                            class="avatar-40 rounded"
                            :src="item.image"
                            alt="img"
                          />
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">{{ item.name }}</h6>
                          <small class="float-right font-size-12">{{
                            item.date
                          }}</small>
                          <p class="mb-0">
                            {{ item.description.substring(0, 40) + "..." }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item" v-nav-toggle>
              <a href="#" class="search-toggle iq-waves-effect">
                <lottie :option="require('../assets/images/small/lottie-mail')" id="lottie-mail" />
                <span class="bg-primary count-mail"></span>
              </a>
              <div class="iq-sub-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0 ">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">{{ $t('nav.allMessages') }}<small class="badge  badge-light float-right pt-1">5</small></h5>
                    </div>
                    <a href="#" class="iq-sub-card" v-for="(item,index) in message" :key="index">
                      <div class="media align-items-center">
                        <div class="">
                          <img class="avatar-40 rounded" :src="item.image" alt="img">
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0 ">{{ item.name }}</h6>
                          <small class="float-left font-size-12">{{ item.date }}</small>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>
        </template>
        <template slot="right">
          <ul class="navbar-list">
            <li class="" v-nav-toggle title="Account">
              <a
                href="#"
                class="
                  search-toggle
                  iq-waves-effect
                  d-flex
                  align-items-center
                  bg-primary
                  rounded
                "
              >
                <!-- <img
                  :src="profile.avatar_url"
                  class="img-fluid rounded"
                  alt="user"
                /> -->
                <Avatar
                  :imageUrl="profile.avatar_url"
                  :backgroundColor="profile.avatar_color"
                  :initials="profile.initials"
                  :prettyName="profile.prettyName"
                  :small="false"
                  :showTooltip="false"
                />
                <!-- <div class="caption">
                  <h6 class="mb-0 line-height text-white">Joe Doe</h6>
                  <span class="font-size-12 text-white">{{
                    $t("nav.user.available")
                  }}</span>
                </div> -->
              </a>
              <div class="iq-sub-dropdown iq-user-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-1 text-white line-height" v-if="profile">
                        {{
                          (profile.first_name || "") +
                          " " +
                          (profile.last_name || "") +
                          (profile.first_name || profile.last_name ? "" : "")
                        }}
                      </h5>
                      <h6 class="mb-0 text-white line-height" v-if="profile">
                        {{ profile.email }}
                      </h6>
                      <span class="text-white font-size-12">
                        {{ prettyRole }}
                      </span>
                    </div>
                    <!-- <a href="#" class="iq-sub-card iq-bg-primary-hover">
                      <div class="media align-items-center">
                        <div class="rounded iq-card-icon iq-bg-primary">
                          <i class="ri-file-user-line"></i>
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">
                            {{ $t("nav.user.profileTitle") }}
                          </h6>
                          <p class="mb-0 font-size-12">
                            {{ $t("nav.user.profileSub") }}
                          </p>
                        </div>
                      </div>
                    </a>
                    <a href="#" class="iq-sub-card iq-bg-primary-hover">
                      <div class="media align-items-center">
                        <div class="rounded iq-card-icon iq-bg-primary">
                          <i class="ri-profile-line"></i>
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">
                            {{ $t("nav.user.profileEditTitle") }}
                          </h6>
                          <p class="mb-0 font-size-12">
                            {{ $t("nav.user.profileEditSub") }}
                          </p>
                        </div>
                      </div>
                    </a> -->
                    <div
                      class="d-inline-block w-100 text-center p-3"
                      title="Sign out"
                    >
                      <a
                        class="bg-primary iq-sign-btn"
                        href="javascript:void(0)"
                        @click="logout"
                        role="button"
                        >{{ $t("nav.user.signout")
                        }}<i class="ri-login-box-line ml-2"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </DemoNavbar2>
      <!-- TOP Nav Bar END -->
      <div id="content-page" class="content-page">
        <!-- <b-container fluid="" v-if="!notBookmarkRouts.includes($route.name)">
          <b-row>
            <BreadCrumb />
          </b-row>
        </b-container> -->
        <transition
          name="router-anim"
          :enter-active-class="`animated ${animated.enter}`"
          mode="out-in"
          :leave-active-class="`animated ${animated.exit}`"
        >
          <router-view />
        </transition>
      </div>
      <!-- <LayoutFixRightSide v-if="$route.name === 'dashboard'" /> -->
    </div>
    <LayoutFooter />
    <div class="fixed-alert-wrapper" v-if="profile.nOfDefaultOrganizations === 0">
      <b-alert :show="true" variant="alert" class="text-white bg-danger mb-0">
        <div class="iq-alert-icon">
          <i class="ri-alert-line"></i>
        </div>
        <div class="iq-alert-text">You have no <b>DEFAULT organization</b> set. Without it, all your data are shared with your colleagues. Please set your <b>DEFAULT organization</b>.</div>
      </b-alert>
    </div>
  </div>
</template>
<script>
import { core } from "../config/pluginInit";
import { Users } from "../FackApi/api/chat";
import { mapActions, mapGetters } from "vuex";
import Loader from "../components/core/loader/Loader";
import CustomLoader from "../components/core/loader/CustomLoader";
import Sidebar from "../components/core/sidebars/Sidebar";
import DemoNavbar2 from "../components/core/navbars/DemoNavbar2";
import DemoSideBarItems from "../FackApi/json/DemoSideBar";
import profile from "../assets/images/user/user-1.jpeg";
import loader from "../assets/images/loader.gif";
import darkLoader from "../assets/images/darkMode/dark-logo.gif";
import Lottie from "../components/core/lottie/Lottie";
import Customizer from "./Components/Customizer";
import LayoutFixRightSide from "./Components/LayoutFixRightSide";
import WhiteLogo from "../assets/images/logo-2.png";
import SmallSidebar from "../components/core/sidebars/SmallSidebar";
import BreadCrumb from "../components/core/breadcrumbs/BreadCrumb";
import LayoutFooter from "./Components/LayoutFooter";
import { getAccount, eraseAccount, isDebug } from "../Utils/account";
import gql from "graphql-tag";
import { accessToken, parseJwt } from "../Utils/auth";
import Avatar from "../views/Demo/Components/Avatar";
import {getOwnerData, prettyName} from '../Utils/getOwnerData';

const PROFILE = gql`
  query profile($id: uuid!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      role
      avatar_url
      avatar_color
      organizations_aggregate(
        where: {
          default: {
            _eq: true
          }
        }
      ){
        aggregate{
          count
        }
      }
    }
  }
`;
export default {
  name: "VerticleLayout",
  components: {
    LayoutFooter,
    LayoutFixRightSide,
    Customizer,
    Lottie,
    Loader,
    CustomLoader,
    Sidebar,
    DemoNavbar2,
    SmallSidebar,
    BreadCrumb,
    Avatar
  },
  computed: {
    ...mapGetters({
      cartCount: "Ecommerce/cartCountState",
      cartItems: "Ecommerce/cartState",
      selectedLang: "Setting/langState",
      langsOptions: "Setting/langOptionState",
      darkMode: "Setting/darkModeState",
      rtlMode: "Setting/rtlModeState",
      colors: "Setting/colorState"
    }),
    toggleSideIcon() {
      let show = true;
      switch (this.$route.name) {
        case "dashboard.home-3":
        case "dashboard.home-4":
        case "dashboard.home-5":
        case "dashboard.home-6":
          show = false;
          break;
      }
      return show;
    },
    prettyRole() {
      if (this?.profile?.role) {
        return this.profile.role.replaceAll("_", " ");
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.layoutSetting(to.name);
    }
  },
  data() {
    return {
      accountLoading: true,
      animated: { enter: "fadeInUp", exit: "fadeOut" },
      userProfile: profile,
      onlyLogo: false,
      onlyLogoText: false,
      sidebarGroupTitle: true,
      logo: loader,
      usersList: Users,
      rtl: false,
      SmallSidebarLogo: WhiteLogo,
      message: [
        {
          image: require("../assets/images/user/user-01.jpg"),
          name: "Nik Emma Watson",
          date: "13 jan"
        },
        {
          image: require("../assets/images/user/user-02.jpg"),
          name: "Greta Life",
          date: "14 Jun"
        },
        {
          image: require("../assets/images/user/user-03.jpg"),
          name: "Barb Ackue",
          date: "16 Aug"
        },
        {
          image: require("../assets/images/user/user-04.jpg"),
          name: "Anna Sthesia",
          date: "21 Sept"
        },
        {
          image: require("../assets/images/user/user-05.jpg"),
          name: "Bob Frapples",
          date: "29 Sept"
        }
      ],
      notification: [
        {
          image: require("../assets/images/user/user-01.jpg"),
          name: "Nik Emma Watson",
          date: "23 hour ago",
          description: "Enjoy smart access to videos, games"
        },
        {
          image: require("../assets/images/user/user-02.jpg"),
          name: "Greta Life",
          date: "14 hour ago",
          description: "Google Chromecast: Enjoy a world of entertainment"
        },
        {
          image: require("../assets/images/user/user-03.jpg"),
          name: "Barb Ackue",
          date: "16 hour ago",
          description: "Dell Inspiron Laptop: Get speed and performance from"
        },
        {
          image: require("../assets/images/user/user-04.jpg"),
          name: "Anna Sthesia",
          date: "21 hour ago",
          description: "Deliver your favorite playlist anywhere in your home "
        },
        {
          image: require("../assets/images/user/user-05.jpg"),
          name: "Bob Frapples",
          date: "11 hour ago",
          description:
            "MacBook Air features up to 8GB of memory, a fifth-generation"
        }
      ],
      notBookmarkRouts: [
        "dashboard.home-1",
        "dashboard.home-2",
        "dashboard.home-3",
        "dashboard.home-4",
        "dashboard.home-5",
        "dashboard.home-6"
      ],
      verticalMenu: []
    };
  },
  apollo: {
    profile: {
      query: PROFILE,
      variables() {
        const { sub } = parseJwt(accessToken());
        return {
          id: sub
        };
      },
      update: data => {
        return {
          ...data.users_by_pk,
          prettyName: prettyName(
            data.users_by_pk.first_name,
            data.users_by_pk.last_name,
            data.users_by_pk.email,
          ),
          ...getOwnerData(data.users_by_pk),
          initials: generateInitials(
            data.users_by_pk.first_name,
            data.users_by_pk.last_name,
            data.users_by_pk.email,
          ),
          nOfDefaultOrganizations: data.users_by_pk.organizations_aggregate?.aggregate?.count,
        };
      }
    }
  },
  mounted: async function() {
    this.layoutSetting(this.$route.name);
    this.loadAccount();

    // filter only allowed routes
    const acc = await getAccount();
    const reducer = (prev, r) => {
      if (r.debug_only === true && isDebug() !== true) {
        return prev
      }
      if (r.link !== "" && acc.allowedRoutes.includes(r.link.name)) {
        return [...prev, r];
      }
      if (r.link === "") {
        const filteredChildren = r.children.filter(ch =>
          acc.allowedRoutes.includes(ch.link.name)
        );
        if (filteredChildren.length > 0) {
          const purifiedRoute = r;
          r.children = filteredChildren;
          return [...prev, purifiedRoute];
        }
      }
      return prev;
    };
    const allowedSidebar = DemoSideBarItems.reduce(reducer, []);
    this.verticalMenu = allowedSidebar;
  },
  methods: {
    async loadAccount() {
      // console.log("NOW LOADING ACCOUNT");
      // try {
      //   const res = await this.$apollo.query({
      //     query: GET_ACCOUNT
      //   });
      //   const acc = res.data.account;
      //   this.$root.setAccount(acc);
      //   this.accountLoading = false;
      // } catch (error) {
      //   console.error(error);
      //   this.$toast.error(
      //     `Failed to load account - please contect our support.`
      //   );
      //   console.log();
      //   this.accountLoading = false;
      //   localStorage.removeItem("user");
      //   localStorage.removeItem("access_token");
      //   this.$router.push({ path: "/auth/login" });
      // }
    },
    layoutSetting(routeName) {
      this.modeChange({ rtl: this.rtlMode, dark: this.darkMode });
      this.onlyLogo = true;
      this.onlyLogoText = true;
      this.sidebarGroupTitle = true;
      switch (routeName) {
        case "dashboard.home-5":
          this.onlyLogoText = true;
          this.onlyLogo = false;
          break;
        case "dashboard.home-6":
          this.logo = WhiteLogo;
          this.onlyLogo = true;
          this.onlyLogoText = false;
          this.sidebarGroupTitle = false;
          break;
        default:
          if (this.darkMode) {
            this.logo = darkLoader;
          } else {
            this.logo = loader;
          }
          break;
      }
    },
    changeLogo(e) {
      this.logo = e;
    },
    sidebarMini() {
      core.triggerSet();
      this.$store.dispatch("Setting/miniSidebarAction");
    },
    logout() {
      const client = this.$apollo.getClient();
      client.resetStore();
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      eraseAccount();
      this.$router.push({ name: "auth.login" });
    },
    langChange(lang) {
      this.langChangeState(lang);
      this.$i18n.locale = lang.value;
      document.getElementsByClassName("iq-show")[0].classList.remove("iq-show");
      if (lang.value === "ar") {
        this.rtlAdd(lang);
      } else {
        this.rtlRemove(lang);
      }
    },
    routerAnimationChange(e) {
      this.animated = e;
    },
    ...mapActions({
      removeToCart: "Ecommerce/removeToCartAction",
      langChangeState: "Setting/setLangAction",
      rtlAdd: "Setting/setRtlAction",
      rtlRemove: "Setting/removeRtlAction",
      modeChange: "Setting/layoutModeAction"
    })
  },
};

function generateInitials(name, surname, email) {
    let initials = '';

    // Check if name and surname are provided
    if (name && surname) {
        initials = `${name[0]}${surname[0]}`;
    } else if (name) {
        // Only name is provided
        initials = name[0];
    } else if (surname) {
        // Only surname is provided
        initials = surname[0];
    } else if (email) {
        // Fallback to email if name and surname are not available
        initials = email.substring(0, 2);
    } else {
        // In case email is also not provided or is empty
        initials = '?';
    }

    return initials.toUpperCase();
}
</script>
<style>
@import url("../assets/css/custom.css");
@import url("../assets/css/PriceSlider.css");
.fixed-alert-wrapper {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1000;

}
</style>
